import { Icon, type IconProps } from "metabase/ui";

import { shouldHideUpsells } from "../should-hide-upsells";

import S from "./UpsellGem.module.css";

export const UpsellGem = (props: Omit<IconProps, "name" | "color">) => {
  if (shouldHideUpsells()) {
    return null;
  }

  return <Icon size={16} name="gem" className={S.UpsellGem} {...props} />;
};
